// extracted by mini-css-extract-plugin
export default {"root":"tooltip_root__5JMMV","arrow":"tooltip_arrow__EBh8q","popper":"tooltip_popper__6VGrE"};